import React from "react";
import { styles } from "./style";

export const CalendarHeader = () => {
  const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const displayDays = () => {
    return DAYS.map((day) => {
      return (
        <p style={styles.days} key={day}>
          {day}
        </p>
      );
    });
  };

  return <div style={styles.container}>{displayDays()}</div>;
};
